import { RateLimitList } from '@/rate-limits/RateLimitList'

export function RateLimits() {
  return <RateLimitList />
}
